<template>
  <div class="index">
    <main>
      <router-view></router-view>
    </main>
    <!-- <footer>
      <router-link :to="item.url" tag="span" v-for="(item,index) in router" :key="item.id">
        <i :class="item.class" @click="changetitle(index)"></i>
        {{item.content}}
      </router-link>
    </footer> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: [
        {
          id: 1,
          url: "/index",
          class: "iconfont icon-yiyuan1",
          content: "互联网医院",
        },
        {
          id: 2,
          url: "/user",
          class: "iconfont icon--_bingren",
          content: "个人中心",
        },
      ], //tabbar信息
    };
  },
  methods: {
    changetitle() {
      console.log("小飞棍来喽")
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  height: 100%;
  background-color: #ededed;
  display: flex;
  flex-direction: column;
  main {
    flex: 1;
    overflow-y: auto;
  }
  footer {
    width: 100%;
    height: 50px;
    flex-shrink: 0;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    user-select: none;
    span {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      &.router-link-active {
        color: #519aff;
      }
    }
    i {
      font-size: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/footerTab.vue